import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { StoreGuard } from './core/guards/store.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./modules/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'select-store',
    canActivate: [AuthGuard],
    loadComponent: () => import('./modules/auth/store-select/store-select.component').then(m => m.StoreSelectComponent)
  },
  { 
    path: '',
    canActivate: [AuthGuard, StoreGuard],
    loadComponent: () => import('./layouts/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./modules/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      {
        path: 'products',
        children: [
          {
            path: '',
            loadComponent: () => import('./modules/products/products.component').then(m => m.ProductsComponent),
          },
          {
            path: 'edit/:productId',
            loadComponent: () => import('./modules/products/product-edit/index').then(m => m.ProductEditComponent),
          }
        ]
      },
      {
        path: 'scheduler',
        children: [
          {
            path: '',
            loadComponent: () => import('./modules/scheduler/scheduler.component').then(m => m.SchedulerComponent),
          },
          {
            path: 'push-failures',
            loadComponent: () => import('./modules/push-failures/push-failures.component').then(m => m.PushFailuresComponent),
          },
          {
            path: 'product-type-sync',
            loadComponent: () => import('./modules/scheduler/product-type-sync/product-type-sync.component').then(m => m.ProductTypeSyncComponent),
          },
          {
            path: 'channel-sync',
            loadComponent: () => import('./modules/scheduler/channel-sync/channel-sync.component').then(m => m.ChannelSyncComponent),
          }
        ]
      },
      {
        path: 'product-type-attributes',
        loadComponent: () => import('./modules/product-type-attributes/product-type-attributes.component').then(m => m.ProductTypeAttributesComponent),
      },
      { path: 'push-failures', redirectTo: '/scheduler/push-failures', pathMatch: 'full' },
      {
        path: 'attributes',
        loadComponent: () => import('./modules/attributes/attributes.component').then(m => m.AttributesComponent),
      },
      {
        path: 'users',
        loadComponent: () => import('./modules/users/users.component').then(m => m.UsersComponent),
        data: { permission: 'USER_MANAGEMENT' }
      },
      {
        path: 'ai-analysis',
        loadChildren: () =>
          import('./modules/ai-analysis/ai-analysis.routes').then((m) => m.AI_ANALYSIS_ROUTES)
      },
    ]
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];
